import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async"; 
import "./App.css";
import { Loader } from "./Components/Loader";
import { Manage } from "./Components/Manage";
import { useLenis } from "./hooks/useLenis";

const App = () => {
  const [loading, setLoading] = useState(true);
  
  useLenis();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500); 
    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Game Zone Hub | Play Best Free HTML5 Games Online</title>
        <meta name="description" content="Play the best free online HTML5 browser games at Game Zone Hub. Enjoy action, puzzle, racing, and arcade games instantly with no downloads required." />
        <meta name="keywords" content="free online games, HTML5 games, browser games, play games online, Game Zone Hub" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Router>
        {loading && (
          <div 
            className="fixed inset-0 z-[9999] bg-[#0b1120] flex items-center justify-center transition-opacity duration-300"
          >
            <Loader />
          </div>
        )}
        <Manage />
      </Router>
    </HelmetProvider>
  );
};

export default App;